 
import React, { useCallback, useState } from 'react';

import * as Analytics from '../../analytics';

interface Props {
  taggingLabel?: string;
  onBlur?: any;
  onFocus?: any;
  [key: string]: any;
}

const callAnalytics = ({
  target,
  dayStartTime,
  monthStartTime,
  yearStartTime,
}): void => {
  if (target?.id?.indexOf('day') > -1)
    Analytics.sendFieldUpdateEvent('Day DOB', Date.now() - dayStartTime);
  if (target?.id?.indexOf('month') > -1)
    Analytics.sendFieldUpdateEvent('Month DOB', Date.now() - monthStartTime);
  if (target?.id?.indexOf('year') > -1)
    Analytics.sendFieldUpdateEvent('Year DOB', Date.now() - yearStartTime);
};

const withTaggingMemorableChangeHandler = (WrappedComponent: any) =>
  function TaggingMemorableChangeClick({
    taggingLabel,
    onBlur,
    onFocus,
    ...rest
  }: Props) {
    const [dayStartTime, setDayStartTime] = useState(0);
    const [monthStartTime, setMonthStartTime] = useState(0);
    const [yearStartTime, setYearStartTime] = useState(0);
    const handleOnBlur = useCallback(
      (...args) => {
        if (onBlur) {
          onBlur(...args);
        }
        if (taggingLabel && taggingLabel === 'Date of birth') {
          const { target } = args[0];
          callAnalytics({
            target,
            dayStartTime,
            monthStartTime,
            yearStartTime,
          });
        }
      },
      [onBlur, taggingLabel, dayStartTime, monthStartTime, yearStartTime],
    );

    const handleOnFocus = useCallback(
      (...args) => {
        if (onFocus) {
          onFocus(...args);
        }
        const { target } = args[0];
        if (target?.id?.indexOf('day') > -1) setDayStartTime(Date.now());
        if (target?.id?.indexOf('month') > -1) setMonthStartTime(Date.now());
        if (target?.id?.indexOf('year') > -1) setYearStartTime(Date.now());
      },
      [onFocus],
    );
    return (
      <WrappedComponent
        {...rest}
        onFocus={handleOnFocus}
        onBlur={handleOnBlur}
      />
    );
  };

export default withTaggingMemorableChangeHandler;
